import React from 'react';
import { View, StyleSheet } from 'react-native';

export function BackgroundVideo() {
  return (
    <View style={styles.container}>
      {/* Video temporarily commented out
      <video
        autoPlay
        muted
        loop
        playsInline
        style={styles.video}
        src={require('../../assets/videos/BackgroundVideo.mp4')}
      />
      */}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100vw',
    height: '100vh',
    zIndex: -999,
    backgroundColor: '#000000',
  },
  video: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}); 